import styled from "@emotion/styled";
import { Box, Chip } from "@mui/material";
import theme from "../../theme";
import { shouldForwardProp } from "../Common.style";

type ChipSelectedProp = {
  isSelected: boolean;
};

export const ChipsWrapper = styled(Box)`
  padding: 4px 12px;
`;

export const ChipsContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  gap: 8px;
`;

export const ChipItem = styled(Chip, {
  shouldForwardProp: prop =>
    shouldForwardProp<ChipSelectedProp>(["isSelected"], prop),
})<ChipSelectedProp>(({ isSelected }) => ({
  backgroundColor: isSelected
    ? theme.palette.primary.main
    : theme.palette.grey[300],
  color: isSelected ? theme.palette.common.white : theme.palette.common.black,
  minWidth: "40px",
  padding: "0 4px",
  "&:hover": {
    background: isSelected
      ? theme.palette.primary.main
      : theme.palette.grey[300],
  },
}));
